export interface Show {
  id: number;
  title: string;
  slug: string;
  cover: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  status: string;
  updateInfo: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  language: string;
  episodeCount: number;
  currentEpisode: number;
  episodes: Episode[];
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export interface Episode {
  id: number;
  title: string;
  duration: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '电视剧', slug: 'tv-series', icon: 'ri-tv-line', count: 1280 },
  { name: '电影', slug: 'movies', icon: 'ri-film-line', count: 3560 },
  { name: '动漫', slug: 'anime', icon: 'ri-emotion-line', count: 890 },
  { name: '综艺', slug: 'variety', icon: 'ri-mic-line', count: 460 },
  { name: '纪录片', slug: 'documentary', icon: 'ri-slideshow-line', count: 320 },
];

export const shows: Show[] = [
  {
    id: 1,
    title: '长安十二时辰',
    slug: 'changan-twelve-hours',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20Tang%20dynasty%20palace%20and%20warriors%20in%20dim%20lighting%2C%20cinematic%20composition%2C%20dark%20moody%20atmosphere%2C%20gold%20and%20crimson%20accents%2C%20movie%20poster%20style%2C%20clean%20background&width=600&height=800&seq=show-cover-01&orientation=portrait',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2019,
    rating: 8.2,
    status: '已完结',
    updateInfo: '全48集',
    description: '唐朝天宝三年，上元节前夕，长安城混入可疑狼卫，死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。该剧以精致的服化道和紧凑的剧情节奏，再现了盛唐时期的繁华与危机。',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 48,
    currentEpisode: 48,
    episodes: Array.from({ length: 48 }, (_, i) => ({ id: i + 1, title: `第${i + 1}集`, duration: '45分钟' })),
    tags: ['古装', '悬疑', '历史', '动作'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '狂飙',
    slug: 'the-knockout',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20two%20men%20in%20dark%20suits%20facing%20off%2C%20dark%20moody%20lighting%2C%20thriller%20atmosphere%2C%20cinematic%20movie%20poster%20style%2C%20deep%20shadows%2C%20clean%20background&width=600&height=800&seq=show-cover-02&orientation=portrait',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2023,
    rating: 8.5,
    status: '已完结',
    updateInfo: '全39集',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 39,
    currentEpisode: 39,
    episodes: Array.from({ length: 39 }, (_, i) => ({ id: i + 1, title: `第${i + 1}集`, duration: '45分钟' })),
    tags: ['犯罪', '悬疑', '扫黑', '剧情'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '流浪地球2',
    slug: 'wandering-earth-2',
    cover: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20poster%20with%20astronaut%20and%20Earth%20in%20space%2C%20epic%20cinematic%20composition%2C%20blue%20and%20orange%20tones%2C%20dramatic%20lighting%2C%20movie%20poster%20style%2C%20clean%20dark%20background&width=600&height=800&seq=show-cover-03&orientation=portrait',
    category: '电影',
    categorySlug: 'movies',
    year: 2023,
    rating: 8.3,
    status: '已上映',
    updateInfo: 'HD高清',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 1,
    currentEpisode: 1,
    episodes: [{ id: 1, title: '正片', duration: '173分钟' }],
    tags: ['科幻', '灾难', '冒险', '特效'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '庆余年第二季',
    slug: 'joy-of-life-s2',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20warrior%20holding%20sword%20in%20palace%2C%20golden%20warm%20lighting%2C%20cinematic%20composition%2C%20elegant%20costume%2C%20movie%20poster%20style%2C%20clean%20background&width=600&height=800&seq=show-cover-04&orientation=portrait',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2024,
    rating: 8.7,
    status: '更新至36集',
    updateInfo: '更新至36/40集',
    description: '范闲从北齐归来后，发现庆国内部暗流涌动。二皇子谋反失败后自尽，长公主的势力被彻底清除。但更大的阴谋正在浮出水面，范闲必须面对更加复杂的朝堂斗争。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 40,
    currentEpisode: 36,
    episodes: Array.from({ length: 40 }, (_, i) => ({ id: i + 1, title: `第${i + 1}集`, duration: '45分钟' })),
    tags: ['古装', '权谋', '玄幻', '剧情'],
    isHot: true,
    isNew: true,
  },
  {
    id: 5,
    title: '斗罗大陆',
    slug: 'soul-land',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20with%20young%20warrior%20in%20martial%20arts%20pose%20surrounded%20by%20energy%2C%20fantasy%20world%20background%2C%20vibrant%20colors%2C%20anime%20style%2C%20clean%20composition&width=600&height=800&seq=show-cover-05&orientation=portrait',
    category: '动漫',
    categorySlug: 'anime',
    year: 2018,
    rating: 8.0,
    status: '连载中',
    updateInfo: '更新至286集',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志后穿越到斗罗大陆。在这片武魂的世界，唐三凭借前世的记忆和天赋，一步步走向巅峰，成为海神。',
    director: '沈乐平',
    actors: ['配音演员'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 300,
    currentEpisode: 286,
    episodes: Array.from({ length: 30 }, (_, i) => ({ id: i + 1, title: `第${i + 1}集`, duration: '20分钟' })),
    tags: ['玄幻', '热血', '战斗', '成长'],
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: '乘风破浪的姐姐',
    slug: 'sisters-who-make-waves',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20female%20singers%20on%20stage%20in%20glamorous%20dresses%2C%20stage%20lighting%2C%20entertainment%20show%20vibe%2C%20colorful%20and%20vibrant%2C%20clean%20background&width=600&height=800&seq=show-cover-06&orientation=portrait',
    category: '综艺',
    categorySlug: 'variety',
    year: 2024,
    rating: 7.8,
    status: '热播中',
    updateInfo: '更新至10期',
    description: '30位年龄30+的女艺人回归舞台，通过多轮竞演，最终组成全新女团出道。节目展现了成熟女性的魅力与实力，传递了"三十而骊"的积极价值观。',
    director: '芒果TV',
    actors: ['多位女艺人'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 12,
    currentEpisode: 10,
    episodes: Array.from({ length: 12 }, (_, i) => ({ id: i + 1, title: `第${i + 1}期`, duration: '120分钟' })),
    tags: ['音乐', '竞演', '女性', '娱乐'],
    isHot: true,
    isNew: true,
  },
  {
    id: 7,
    title: '舌尖上的中国',
    slug: 'a-bite-of-china',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20traditional%20Chinese%20cuisine%20closeup%2C%20warm%20lighting%2C%20steaming%20dishes%2C%20rustic%20kitchen%20background%2C%20appetizing%20composition%2C%20clean%20design&width=600&height=800&seq=show-cover-07&orientation=portrait',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2012,
    rating: 9.4,
    status: '已完结',
    updateInfo: '全7集',
    description: '围绕中国人对美食和生活的美好追求，用具体人物故事串联起中国各地美食生态。从食材获取到烹饪技艺，从传统风味到现代创新，展现中华饮食文化的精致和源远流长。',
    director: '陈晓卿',
    actors: ['旁白'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 7,
    currentEpisode: 7,
    episodes: Array.from({ length: 7 }, (_, i) => ({ id: i + 1, title: `第${i + 1}集`, duration: '50分钟' })),
    tags: ['美食', '文化', '人文', '传统'],
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: '满江红',
    slug: 'full-river-red',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20film%20poster%20with%20ancient%20Chinese%20courtyard%20and%20soldiers%2C%20dark%20red%20and%20gold%20tones%2C%20mysterious%20atmosphere%2C%20cinematic%20movie%20poster%20style%2C%20clean%20background&width=600&height=800&seq=show-cover-08&orientation=portrait',
    category: '电影',
    categorySlug: 'movies',
    year: 2023,
    rating: 7.4,
    status: '已上映',
    updateInfo: 'HD高清',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进巨大阴谋之中。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 1,
    currentEpisode: 1,
    episodes: [{ id: 1, title: '正片', duration: '159分钟' }],
    tags: ['历史', '悬疑', '喜剧', '剧情'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: '凡人修仙传',
    slug: 'a-mortals-journey',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20with%20cultivator%20flying%20on%20sword%20in%20misty%20mountains%2C%20martial%20arts%20fantasy%20world%2C%20ethereal%20atmosphere%2C%20clean%20anime%20art%20style&width=600&height=800&seq=show-cover-09&orientation=portrait',
    category: '动漫',
    categorySlug: 'anime',
    year: 2020,
    rating: 8.4,
    status: '连载中',
    updateInfo: '更新至82集',
    description: '平凡少年韩立出身贫寒，为了家人前往七玄门试炼，从此踏上修仙之路。在尔虞我诈、弱肉强食的修仙世界中，韩立凭借谨慎的性格和过人的智慧，一步步走向巅峰。',
    director: '王昕',
    actors: ['配音演员'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 100,
    currentEpisode: 82,
    episodes: Array.from({ length: 18 }, (_, i) => ({ id: i + 1, title: `第${i + 1}集`, duration: '22分钟' })),
    tags: ['修仙', '玄幻', '热血', '冒险'],
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '三体',
    slug: 'three-body',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20three%20suns%20in%20space%20and%20mysterious%20signal%2C%20dark%20cosmic%20background%2C%20cinematic%20composition%2C%20mysterious%20and%20epic%20atmosphere%2C%20clean%20poster%20design&width=600&height=800&seq=show-cover-10&orientation=portrait',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2023,
    rating: 8.1,
    status: '已完结',
    updateInfo: '全30集',
    description: '纳米科学家汪淼被警官史强带到联合作战中心，潜入科学边界组织进行调查。在过程中，汪淼接触到一个名为"三体"的神秘游戏，由此揭开地球文明与三体文明的首次接触。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 30,
    currentEpisode: 30,
    episodes: Array.from({ length: 30 }, (_, i) => ({ id: i + 1, title: `第${i + 1}集`, duration: '45分钟' })),
    tags: ['科幻', '悬疑', '剧情', '改编'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '奔跑吧兄弟',
    slug: 'keep-running',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20running%20outdoors%20smiling%2C%20bright%20sunny%20day%2C%20energetic%20vibe%2C%20entertainment%20show%20style%2C%20clean%20vibrant%20background&width=600&height=800&seq=show-cover-11&orientation=portrait',
    category: '综艺',
    categorySlug: 'variety',
    year: 2024,
    rating: 6.9,
    status: '热播中',
    updateInfo: '更新至8期',
    description: '固定成员与新嘉宾一起参与各种趣味游戏和挑战任务，在欢笑与竞争中展现明星真实的一面。节目通过户外竞技的形式，为观众带来轻松愉快的观看体验。',
    director: '浙江卫视',
    actors: ['李晨', '郑恺', '杨颖', '白鹿'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 12,
    currentEpisode: 8,
    episodes: Array.from({ length: 12 }, (_, i) => ({ id: i + 1, title: `第${i + 1}期`, duration: '100分钟' })),
    tags: ['户外', '竞技', '搞笑', '真人秀'],
    isHot: false,
    isNew: true,
  },
  {
    id: 12,
    title: '航拍中国',
    slug: 'aerial-china',
    cover: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Chinese%20mountains%20and%20rivers%20from%20drone%2C%20breathtaking%20landscape%2C%20golden%20hour%20lighting%2C%20documentary%20poster%20style%2C%20natural%20beauty%2C%20clean%20composition&width=600&height=800&seq=show-cover-12&orientation=portrait',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2017,
    rating: 9.1,
    status: '已完结',
    updateInfo: '全34集',
    description: '以空中视角俯瞰中国，立体化展示中国历史人文景观、自然地理风貌及经济社会发展变化。每集选取各省市区最具代表性和观赏性的景观，展现一个既熟悉又新鲜的美丽中国。',
    director: '央视纪录',
    actors: ['旁白'],
    region: '中国大陆',
    language: '汉语普通话',
    episodeCount: 34,
    currentEpisode: 34,
    episodes: Array.from({ length: 34 }, (_, i) => ({ id: i + 1, title: `第${i + 1}集`, duration: '50分钟' })),
    tags: ['自然', '地理', '人文', '航拍'],
    isHot: false,
    isNew: false,
  },
];

export const bannerShows = shows.filter((s) => s.isHot).slice(0, 4);

export const latestShows = shows.filter((s) => s.isNew);

export const hotShows = shows.filter((s) => s.isHot);

export const allShows = shows;

export function getShowsByCategory(slug: string): Show[] {
  return shows.filter((s) => s.categorySlug === slug);
}

export function getShowById(id: number): Show | undefined {
  return shows.find((s) => s.id === id);
}

export function getRelatedShows(show: Show, count: number = 6): Show[] {
  return shows
    .filter((s) => s.id !== show.id && (s.categorySlug === show.categorySlug || s.tags.some((t) => show.tags.includes(t))))
    .slice(0, count);
}